/**
 * Veluna guide popup - email first; the code, the topic link and the guide
 * follow on the success screen.
 * Rebuilt 2026-09-22 in the guides' design language. REDESIGNED 2026-10-01
 * (owner-approved mock): bone card with a linen media panel showing the guide
 * cover on desktop, a bottom sheet with a cover thumbnail on phones. The
 * Mind/Body/Skin picker is no longer the first step: the popup opens straight
 * on the email step on every surface. Concern: articles keep articleConcern()
 * (VELUNA_BLOG_CLUSTER); home, browse and unmapped articles default to Mind
 * Calm (mc). Triggers, suppression, measurement (gtag veluna_popup_shown /
 * veluna_popup_dismissed), the topic map and the POST body are unchanged.
 * Replaces the first block of veluna-pdf-capture.js.
 *
 * TAKEOVER + FLIP (2026-10-01, owner): the card is now a full-viewport layout
 * (desktop: linen media panel left 45% with the guide cover, bone content panel
 * right; phones: full-screen bone sheet with a 96x126 cover thumbnail above the
 * headline). The first step is no longer the email field: three face-down cards,
 * the visitor flips one, it reveals the offer, then the email step follows.
 * HONESTY RULE: every card reveals the SAME real offer (10% off the first set and
 * the sleep guide) and no copy claims chance, luck, winning or a prize. Steps are
 * measured with gtag veluna_popup_step {engine, surface, step: flip | email}.
 * The exit-intent subscription now also asks for the Back-button trap
 * (VelunaExitIntent, back: true): one history entry, one 'back' signal per page
 * load, transparent when the engine refuses.
 *
 * PHONE BAND + PAGE-ONLY DISMISSAL + EARLIER TRIGGERS (2026-10-01, owner, evening):
 *   - phones (max-width 640px): the full-screen bone sheet opens with a linen image band
 *     across the top (34vh, 220 to 300 px, the guide cover centred at 85% of the band's
 *     height, the close X over the band) and the content starts directly under it,
 *     top-aligned, scrolling on its own when it is taller than the viewport. The floating
 *     96x126 thumbnail is gone. Desktop (two-panel takeover) is unchanged.
 *   - closing (X, No thanks, Esc, backdrop) only silences THIS page load (closedThisPage).
 *     No dismissal key is written any more, the 2-per-visit cap and the 60 s cross-page
 *     cooldown are gone, and the legacy dismissal keys still sitting in visitors' browsers
 *     are ignored. A capture (any capture flag) still silences every surface.
 *   - articles and browse pages on touch: 30% depth after 10 s (was 40% / 15 s). Home
 *     keeps 8 s dwell / 30% scroll; the exit kinds are unchanged.
 *
 * SURFACES
 *   homepage       scroll past half, exit intent (desktop), or 45s on the page
 *   blog articles  gentle only (2026-09-23): desktop 60% read or exit intent;
 *                  touch 60% read AND 30s on the page. The article's mapped
 *                  concern (VELUNA_BLOG_CLUSTER) is pre-selected. source
 *                  article_capture. Replaces veluna-homepage-popup.js there.
 *   cart           NONE since 2026-09-23 (it competed with checkout).
 *
 * DISMISSAL (2026-09-23): X, Esc, backdrop or "No thanks" suppresses the popup
 * for 7 days and for the rest of the session. It used to write only a 60s
 * cooldown and re-arm a timer, so it came back every minute. After a capture
 * nothing asks again. generate_lead fires on a 2xx only.
 *
 * ROUTING. Every submission carries a concern code (mc / dr / ss) at the top
 * level. The email engine's welcome sequence fills {concern_name}, {guide_url}
 * and {product_url} from that code, so the first email is that ritual's guide.
 * Circadian Reset (cr) is no longer offered: the tuning was hidden 2026-09-22.
 *
 * WHAT WAS REMOVED: the fourth option (Circadian Reset), "14-page" (Deep
 * Restore's guide is 13), and "personalized".
 *
 * Captured state is written to every key the site's other captures read
 * (veluna_email_captured, veluna_pdf_captured, veluna_quiz_email), so a person
 * who signs up here is never asked again anywhere else.
 */
(function () {
  'use strict';

  var CONFIG = {
    backend: {
      url: 'https://ary09mimgg.execute-api.us-east-2.amazonaws.com/Prod/subscribe',
      sequence: 'welcome',
      popupVariant: 'guide_v2'
    },
    timing: { dwellMs: 5000, cooldownMs: 60000, scrollThreshold: 0.2,   /* owner 2026-10-01 max leads: 5 s / 20% / 20% / 5 s (was 8 s / 30% / 30% / 10 s) */
              articleScroll: 0.2, articleMobileMinMs: 5000, suppressMs: 7 * 24 * 60 * 60 * 1000 },   /* 2026-10-01: 30% after 10 s (was 40% / 15 s) */
    storage: {
      captured: 'veluna_email_captured',
      dismissed: 'veluna_popup_dismissed_forever',
      lastShown: 'veluna_popup_last_shown',
      cartShown: 'veluna_cart_popup_shown',
      dismissedUntil: 'veluna_popup_dismissed_until',
      sessionDismissed: 'veluna_popup_dismissed_session'
    },
    concerns: [
      { id: 'mc', name: 'Mind', ritual: 'Mind Calm', line: 'A head that will not stop at lights out.',
        sub: 'Quiet the Mental Chatter', product: '/products/mind-calm-ritual-set', match: 'mind-calm',
        guide: 'https://cdn.shopify.com/s/files/1/0660/1372/4750/files/Veluna-Mind-Calm-Sleep-Guide_498c431a-e208-4dc2-a82f-ecfe391e66ee.pdf?v=1790031056' },
      { id: 'dr', name: 'Body', ritual: 'Deep Restore', line: 'A body still holding the day.',
        sub: 'Release Physical Tension', product: '/products/deep-restore-ritual-set', match: 'deep-restore',
        guide: 'https://cdn.shopify.com/s/files/1/0660/1372/4750/files/Veluna-Deep-Restore-Sleep-Guide_4b0e977e-e588-46b3-a770-60a1a3dea23d.pdf?v=1790031062' },
      { id: 'ss', name: 'Skin', ritual: 'Sacred Soothe', line: 'Short nights that show on your face.',
        sub: 'Nurture Your Spirit', product: '/products/sacred-soothe-ritual-set-1', match: 'sacred-soothe',
        guide: 'https://cdn.shopify.com/s/files/1/0660/1372/4750/files/Veluna-Sacred-Soothe-Sleep-Guide_6e6345f9-2f2e-434f-b89d-4fe916f28d47.pdf?v=1790031067' }
    ]
  };

  var popupEl = null, selected = null, isOpen = false, dwellTimer = null, triggersInstalled = false, releaseFocus = null;
  var closedThisPage = false;   /* 2026-10-01 (owner): a close silences the popup for this page load only */

  function ls(k) { try { return localStorage.getItem(k); } catch (_) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (_) {} }
  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (_) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (_) {} }
  function isCaptured() {
    return ls(CONFIG.storage.captured) === 'true' || !!ls('veluna_pdf_captured') ||
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((ls('veluna_quiz_email') || '').trim());
  }
  /* 2026-10-01 (owner): "if I exit a popup on one page and navigate to another page I should
     receive the new popup unless I have entered my email already". A close counts for THIS
     page load only. Nothing is written to storage and the legacy keys (veluna_popup_dismissed_until,
     its per-surface variants, veluna_popup_dismissed_session, veluna_popup_dismissed_forever) are
     ignored, so visitors who closed an older version are not silenced for 7 days. */
  function isPermanentlyDismissed() { return closedThisPage; }
  function fireLead(p) {
    try { if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', p); } catch (_) {}
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'generate_lead', source: p.source, concern: p.concern, surface: p.surface }); } catch (_) {}
  }
  function sourceName() { return surface() === 'article' ? 'article_capture' : 'veluna_quiz_popup'; }
  /* 2026-10-01: popup measurement shared with every capture engine. One GA4 event per
     open (engine, surface, trigger) and one per dismissal (engine, surface). The
     existing dataLayer pushes stay as they are. */
  function gaPopup(ev, p) { try { if (typeof window.gtag === 'function') window.gtag('event', ev, p); } catch (_) {} }
  function triggerName(r) {
    r = String(r || '');
    if (r === 'exit-intent' || r === 'scroll' || r === 'scroll-up' || r === 'idle') return r;
    if (r === 'dwell' || r === 'scroll-dwell') return 'dwell';
    return 'manual';
  }
  function articleConcern() {
    var id = String(window.VELUNA_BLOG_CLUSTER || '').toLowerCase();
    return CONFIG.concerns.filter(function (c) { return c.id === id; })[0] || null;
  }
  /* 2026-10-01: topic-matched copy on articles, keyed by words in the article handle
     (first match wins). Each line promises exactly what happens: the code and the page
     link appear on the success screen now, the guide arrives by email. No health claims.
     On the linked page itself the default copy shows instead. */
  var TOPICS = [
    { re: /magnesium/, h: 'Reading about magnesium doses?',
      sub: 'Get your 10% off code now, the dose table link, and the sleep guide by email.',
      link: '/blogs/journal/sleep-supplement-doses-used-in-trials', label: 'Open the dose table' },
    { re: /melatonin/, h: 'Choosing a melatonin dose?',
      sub: 'Get your 10% off code now, the dose chart link, and the sleep guide by email.',
      link: '/blogs/journal/low-dose-melatonin-how-to-choose-a-dose', label: 'Open the dose chart' },
    { re: /biotin|hair-skin|gummies/, h: 'Comparing hair, skin and nails gummies?',
      sub: 'Get your 10% off code now, the what-to-check list link, and the sleep guide by email.',
      link: '/blogs/journal/hair-skin-and-nails-gummies-what-to-check', label: 'Open the what-to-check list' },
    { re: /collagen/, h: 'Comparing collagen powders?',
      sub: 'Get your 10% off code now, the collagen powder guide link, and the sleep guide by email.',
      link: '/blogs/journal/how-to-choose-a-collagen-powder', label: 'Open the collagen powder guide' },
    { re: /ashwagandha/, h: 'Comparing ashwagandha supplements?',
      sub: 'Get your 10% off code now, the ashwagandha buying guide link, and the sleep guide by email.',
      link: '/blogs/journal/how-to-choose-an-ashwagandha-supplement', label: 'Open the ashwagandha buying guide' }
  ];
  function topic() {
    if (surface() !== 'article') return null;
    var path = window.location.pathname.replace(/\/+$/, '');
    var m = /^\/blogs\/[^/]+\/([^/?#]+)/.exec(path);
    var handle = m ? m[1].toLowerCase() : '';
    for (var i = 0; i < TOPICS.length; i++) {
      if (TOPICS[i].re.test(handle)) return path === TOPICS[i].link ? null : TOPICS[i];
    }
    return null;
  }
  /* veluna_popup_last_shown is kept for analytics only (2026-10-01): no cooldown and no
     per-visit cap read it any more. */
  /* 2026-10-01 (owner): at most 2 showings per visit per popup type. */
  function popShows(t) { try { return +(sessionStorage.getItem('veluna_pop_shows_' + t) || 0); } catch (_) { return 0; } }
  function popCount(t) { try { sessionStorage.setItem('veluna_pop_shows_' + t, String(popShows(t) + 1)); } catch (_) {} }
  function recordShown() { lsSet(CONFIG.storage.lastShown, String(Date.now())); }

  function surface() {
    var p = window.location.pathname;
    if (p.indexOf('/checkout') !== -1) return null;
    /* 2026-09-23: no capture on the cart at all; it competed with checkout. */
    if (p === '/cart' || p.indexOf('/cart/') === 0) return null;
    if (p === '/' || p === '/index' || p === '') return 'home';
    if (/^\/blogs\/[^/]+\/[^/]+/.test(p)) return 'article';
    /* 2026-09-29: browse pages get the guide on exit intent only (desktop).
       Pages with their own capture or a form are left out. */
    if (/^\/(pages\/(ritual-quiz|my-ritual|mind-calm|contact|partner)|account|search|password)/.test(p)) return null;
    if (/^\/(pages|collections)\//.test(p) || /^\/blogs\/[^/]+\/?$/.test(p)) return 'browse';
    return null;
  }

  /* ?popup_preview=1 bypasses "already signed up", cooldowns and the guard so
     the owner can see the popup on a browser that has signed up before. */
  var PREVIEW = /[?&]popup_preview=1\b/.test(window.location.search);

  /* An exit (pointer leaving the window) may open while the buy box is on
     screen; every other guard rule still applies. 2026-09-29. */
  var EXITING = false;
  function guardAllows(id) {
    var G = window.VelunaCaptureGuard;
    if (!G) return true;
    var r = G.reason ? G.reason(id, surface()) : (G.mayShow(id, surface()) ? null : 'blocked');
    return r === null || (EXITING && r === 'commerce_configuration_visible');
  }
  function shouldShow() {
    if (!surface()) return false;
    if (PREVIEW) return !isOpen;
    var claimed = (window.__vlnPageSpecific || []).filter(function (id) { return id && id !== 'pdf-capture'; });
    if (claimed.length) return false;
    if (window.VelunaCaptureGuard && window.VelunaCaptureGuard.hasPageSpecific('pdf-capture')) return false;
    if (!guardAllows('pdf-capture')) return false;
    if (isCaptured() || isPermanentlyDismissed() || isOpen) return false;
    if (popShows('guide') >= 2) return false;   /* owner 2026-10-01: max 2 per visit */   /* 2026-10-01: no per-visit cap, no cross-page cooldown; a close counts on this page only */
    if (surface() === 'cart' && ssGet(CONFIG.storage.cartShown)) return false;
    return true;
  }

  /* 2026-10-01 redesign. The three families come from the theme's own variables
     (snippets/veluna-typography.liquid: --veluna-serif / --veluna-ui / --veluna-mono)
     with literal fallbacks; !important because several theme stylesheets load
     asynchronously and would otherwise win on declaration order. Hooks kept:
     .vqp__overlay(.is-open), .vqp__card, .vqp__close, .vqp__frame[data-body],
     .vqp__input, .vqp__btn[data-submit], data-topic-link, data-skip. */
  function injectStyles() {
    if (document.getElementById('vqp-styles')) return;
    var SERIF = 'var(--veluna-serif,Newsreader,Georgia,serif)!important';
    var UI = 'var(--veluna-ui,"Hanken Grotesk",system-ui,sans-serif)!important';
    var MONO = 'var(--veluna-mono,"DM Mono",ui-monospace,monospace)!important';
    var O = '.vqp__overlay ';
    var css = [
      /* The dim + blur stays behind the panels for the fade in and out. */
      '.vqp__overlay{position:fixed;inset:0;background:rgba(27,27,27,.45);-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px);z-index:999999;display:flex;align-items:stretch;justify-content:stretch;padding:0;box-sizing:border-box;opacity:0;transition:opacity .25s ease;}',
      '.vqp__overlay.is-open{opacity:1;}',
      '.vqp__overlay *,.vqp__overlay *::before,.vqp__overlay *::after{box-sizing:border-box;}',
      /* Takeover (2026-10-01): two panels fill the viewport, linen media left (45%), bone content right. */
      '.vqp__card{position:relative;display:grid;grid-template-columns:45% minmax(0,1fr);grid-template-rows:minmax(0,1fr);width:100%;height:100%;max-width:none;max-height:none;overflow:hidden;background:#FBF9F5;color:#131313;border:0;border-radius:0;box-shadow:none;text-align:left;font-family:' + UI + ';transform:translateY(12px);transition:transform .3s ease;}',
      '.vqp__overlay.is-open .vqp__card{transform:none;}',
      O + '.vqp__card:focus{outline:none;}',
      '.vqp__media{display:flex;align-items:center;justify-content:center;min-width:0;min-height:0;padding:48px;background:#E9DDD1;}',
      '.vqp__media img{display:block;width:auto;height:auto;max-width:min(100%,440px);max-height:72vh;border-radius:8px;box-shadow:0 18px 44px rgba(0,0,0,.2);}',
      /* Content column: vertically centred while it fits, scrolls from the top when it does not
         (the two flex spacers take the free space and collapse to nothing on overflow). */
      '.vqp__frame{display:flex;flex-direction:column;min-width:0;min-height:0;overflow-x:hidden;overflow-y:auto;overscroll-behavior:contain;-webkit-overflow-scrolling:touch;padding:72px clamp(32px,7vw,96px) 48px;background:#FBF9F5;text-align:left;}',
      '.vqp__frame::before,.vqp__frame::after{content:"";display:block;flex:1 0 0;min-height:0;}',
      '.vqp__frame>*{flex:0 0 auto;width:100%;max-width:560px;}',
      O + '.vqp__close{position:absolute;top:16px;right:16px;z-index:2;width:44px;height:44px;min-width:0;min-height:0;display:flex;align-items:center;justify-content:center;padding:0;margin:0;background:transparent;border:0;border-radius:50%;cursor:pointer;color:#6A6D78;line-height:0;}',
      O + '.vqp__close:hover{color:#131313;background:rgba(19,19,19,.06);}',
      '.vqp__head{display:flex;align-items:center;gap:14px;}',
      '.vqp__head-text{min-width:0;flex:1 1 auto;}',
      O + '.vqp__brand{margin:0 0 16px;font-family:' + MONO + ';font-weight:500;font-size:11px;line-height:1;letter-spacing:.14em;text-transform:uppercase;color:#9A7B55;}',
      O + '.vqp__h{margin:0 0 14px;font-family:' + SERIF + ';font-weight:500!important;font-size:36px;line-height:1.12;letter-spacing:-.01em;color:#131313!important;text-wrap:balance;}',
      O + '.vqp__sub{margin:0 0 20px;max-width:none;font-family:' + UI + ';font-size:17px;line-height:1.5;color:#4a4d57;}',
      /* Step 1: three face-down cards, the same real offer behind each. */
      '.vqp__cards{display:flex;gap:16px;margin:4px 0 0;}',
      O + '.vqp__cardbtn{position:relative;flex:0 0 auto;width:144px;height:auto;min-width:0;min-height:0;margin:0;padding:0;background:transparent;border:0;border-radius:14px;box-shadow:none;cursor:pointer;-webkit-tap-highlight-color:transparent;transition:transform .2s ease,opacity .3s ease;}',
      O + '.vqp__cardbtn:hover{transform:translateY(-4px);background:transparent;}',
      '.vqp__cardin{position:relative;display:block;width:100%;height:0;padding:133.333% 0 0;transform:perspective(900px) rotateY(0deg);transform-style:preserve-3d;transition:transform .5s ease;}',
      '.vqp__cardbtn.is-flipped .vqp__cardin{transform:perspective(900px) rotateY(180deg);}',
      '.vqp__cardface{position:absolute;top:0;right:0;bottom:0;left:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:10px;padding:10px;background:#FBF9F5;border:1px solid #ECE7DF;border-radius:14px;box-shadow:0 10px 24px rgba(20,20,20,.08);-webkit-backface-visibility:hidden;backface-visibility:hidden;}',
      O + '.vqp__cardbtn:hover .vqp__cardface{border-color:#D9CBB8;box-shadow:0 16px 32px rgba(20,20,20,.12);}',
      '.vqp__cardface--front{transform:rotateY(180deg);background:#fff;border-color:#C8A27B;}',
      '.vqp__moon{display:block;width:30px;height:30px;border-radius:50%;box-shadow:inset -9px 4px 0 0 #C8A27B;}',
      O + '.vqp__cardnum{display:block;margin:0;font-family:' + MONO + ';font-weight:500;font-size:13px;line-height:1;letter-spacing:.14em;color:#9A7B55;}',
      O + '.vqp__cardoffer{display:block;margin:0;font-family:' + SERIF + ';font-weight:500!important;font-size:24px;line-height:1.05;color:#131313!important;text-align:center;}',
      O + '.vqp__cardline{display:block;margin:0;font-family:' + UI + ';font-size:13px;line-height:1.3;color:#4a4d57;text-align:center;}',
      '.vqp__cards.is-picked .vqp__cardbtn{cursor:default;}',
      '.vqp__cards.is-picked .vqp__cardbtn:not(.is-flipped){opacity:.4;pointer-events:none;}',
      O + '.vqp__cards.is-picked .vqp__cardbtn:hover{transform:none;}',
      '.vqp__form{display:flex;flex-direction:column;gap:0;text-align:left;margin:0;}',
      '.vqp__row{display:flex;gap:10px;}',
      O + '.vqp__input{flex:1 1 auto;min-width:0;width:100%;height:50px;min-height:50px;margin:0;padding:0 16px;border:1px solid #D5CFC4;border-radius:12px;background:#fff;color:#1b1b1b;font-family:' + UI + ';font-size:16px;line-height:normal;box-shadow:none;-webkit-appearance:none;appearance:none;}',
      O + '.vqp__input::placeholder{color:#8A8D98;opacity:1;}',
      O + '.vqp__input:focus{outline:2px solid #C8A27B;outline-offset:1px;border-color:#C8A27B;}',
      O + '.vqp__btn{display:inline-flex;align-items:center;justify-content:center;flex:0 0 auto;height:50px;min-height:50px;margin:0;padding:0 22px;border:0;border-radius:12px;background:#C8A27B;color:#131313;font-family:' + UI + ';font-size:16px;font-weight:600;line-height:1;white-space:nowrap;cursor:pointer;text-decoration:none;-webkit-appearance:none;appearance:none;}',
      O + '.vqp__btn:hover{background:#BE966D;color:#131313;}',
      O + '.vqp__btn[disabled]{opacity:.6;cursor:wait;}',
      O + '.vqp__error{min-height:0;margin:0;font-family:' + UI + ';font-size:13px;line-height:1.4;color:#A5522B;}',
      O + '.vqp__error:not(:empty){margin-top:8px;}',
      O + '.vqp__legal{margin:12px 0 0;font-family:' + UI + ';font-size:12.5px;line-height:1.5;color:#6A6D78;text-align:left;}',
      O + '.vqp__trust{display:flex;flex-wrap:wrap;gap:16px;margin:18px 0 0;font-family:' + MONO + ';font-weight:500;font-size:11px;line-height:1;letter-spacing:.08em;text-transform:uppercase;color:#6A6D78;}',
      O + '.vqp__skip{display:inline-block;align-self:flex-start;width:auto;margin:22px 0 0;padding:0;background:transparent;border:0;cursor:pointer;font-family:' + UI + ';font-size:14px;line-height:1.4;color:#6A6D78;text-decoration:underline;text-underline-offset:3px;}',
      O + '.vqp__skip:hover{color:#131313;}',
      '.vqp__code{display:flex;align-items:center;flex-wrap:wrap;gap:10px;margin:6px 0 10px;}',
      O + '.vqp__code-value{display:inline-block;padding:10px 16px;background:#fff;border:1px dashed #C8A27B;border-radius:10px;font-family:' + MONO + ';font-weight:500;font-size:26px;line-height:1;letter-spacing:.06em;color:#131313;user-select:all;-webkit-user-select:all;}',
      O + '.vqp__copy{height:44px;margin:0;padding:0 16px;border:1px solid #D5CFC4;border-radius:10px;background:#fff;color:#131313;font-family:' + UI + ';font-size:14px;font-weight:600;line-height:1;cursor:pointer;-webkit-appearance:none;appearance:none;}',
      O + '.vqp__copy:hover{border-color:#C8A27B;}',
      O + '.vqp__copied{min-height:0;margin:0;font-family:' + UI + ';font-size:13px;line-height:1.4;color:#4a4d57;}',
      O + '.vqp__copied:not(:empty){margin:0 0 10px;}',
      '.vqp__links{display:flex;flex-wrap:wrap;gap:10px;margin:14px 0 0;}',
      O + '.vqp__link{display:inline-block;margin:0;padding:11px 16px;border:1px solid #D5CFC4;border-radius:12px;background:#fff;color:#131313;font-family:' + UI + ';font-size:15px;font-weight:600;line-height:1.2;text-decoration:none;}',
      O + '.vqp__link:hover{border-color:#C8A27B;color:#131313;}',
      O + '.vqp__link--topic{background:#C8A27B;border-color:#C8A27B;}',
      O + '.vqp__pick{display:flex;flex-wrap:wrap;align-items:center;gap:4px 14px;margin:14px 0 0;font-family:' + UI + ';font-size:13px;line-height:1.4;color:#6A6D78;}',
      O + '.vqp__pick a{color:#131313;font-weight:600;text-decoration:underline;text-underline-offset:3px;}',
      O + '.vqp__close:focus-visible,' + O + '.vqp__btn:focus-visible,' + O + '.vqp__skip:focus-visible,' + O + '.vqp__copy:focus-visible,' + O + '.vqp__link:focus-visible,' + O + '.vqp__pick a:focus-visible{outline:2px solid #C8A27B;outline-offset:3px;}',
      O + '.vqp__cardbtn:focus-visible{outline:2px solid #C8A27B;outline-offset:4px;}',
      '@media (max-width:1024px){.vqp__card{grid-template-columns:42% minmax(0,1fr);}.vqp__frame{padding:64px 32px 40px;}.vqp__media{padding:32px;}}',
      /* Phone (2026-10-01, owner): a full-screen bone sheet with a linen image band across the
         top (34vh, 220 to 300 px; the cover centred at 85% of the band = clamp(187px,28.9vh,255px)),
         the close X over the band, the content directly under it, top-aligned (no centring
         spacers, no thumbnail), scrolling on its own while the band stays put. Three cards in a
         row, each a third of the width and 150 px tall. Step 2 and 3 controls are full width. */
      '@media (max-width:640px){' +
        '.vqp__card{display:flex;flex-direction:column;height:100%;}' +
        '.vqp__media{display:flex;flex:0 0 auto;align-items:center;justify-content:center;width:100%;height:34vh;min-height:220px;max-height:300px;padding:0 20px;background:#E9DDD1;}' +
        '.vqp__media img{width:auto;height:auto;max-width:100%;max-height:clamp(187px,28.9vh,255px);border-radius:6px;box-shadow:0 10px 24px rgba(0,0,0,.18);}' +
        '.vqp__frame{flex:1 1 auto;min-height:0;padding:20px 20px 28px;overflow-y:auto;}' +
        '.vqp__frame::before,.vqp__frame::after{display:none;}' +
        '.vqp__frame>*{max-width:none;}' +
        O + '.vqp__close{top:12px;right:12px;}' +
        '.vqp__head{display:block;margin:0 0 10px;}' +
        O + '.vqp__brand{margin:0 0 8px;}' +
        O + '.vqp__h{margin:0;font-size:26px;}' +
        O + '.vqp__sub{margin:0 0 16px;font-size:15px;}' +
        '.vqp__cards{gap:10px;}' +
        O + '.vqp__cardbtn{flex:1 1 0;width:auto;max-width:none;}' +
        '.vqp__cardin{height:150px;padding:0;}' +
        O + '.vqp__cardoffer{font-size:20px;}' +
        O + '.vqp__cardline{font-size:12px;}' +
        '.vqp__row{flex-direction:column;gap:10px;}' +
        O + '.vqp__input{height:52px;min-height:52px;}' +
        O + '.vqp__btn{width:100%;height:52px;min-height:52px;}' +
        O + '.vqp__code-value{font-size:22px;}' +
        '.vqp__links{flex-direction:column;gap:10px;}' +
        O + '.vqp__link{display:block;width:100%;text-align:center;}' +
      '}',
      /* Reduced motion: no fade travel, no 3D flip (the faces swap), no hover lift. */
      '@media (prefers-reduced-motion:reduce){.vqp__overlay,.vqp__card,.vqp__cardin,' + O + '.vqp__cardbtn{transition:none;}.vqp__card{transform:none;}' + O + '.vqp__cardbtn:hover{transform:none;}}'
    ].join('');
    var style = document.createElement('style');
    style.id = 'vqp-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  /* The guide cover (772x1000 PNG, 68 KB; the CDN's ?width=600 re-encode is larger). */
  var GUIDE_COVER = 'https://cdn.shopify.com/s/files/1/0660/1372/4750/files/veluna-mind-calm-sleep-guide-cover_ad0b64d6-7b31-449d-ac5c-085277c247ca.png';
  function defaultConcern() {
    return CONFIG.concerns.filter(function (c) { return c.id === 'mc'; })[0] || CONFIG.concerns[0];
  }
  /* "works until" date: the engine's value as given, or a readable date when it is
     an ISO timestamp (2026-10-08T23:59:00-04:00 -> Thursday, October 8). */
  function endsLabel(s) {
    s = String(s || '');
    if (!/^\d{4}-\d{2}-\d{2}/.test(s)) return s;
    var d = new Date(s);
    if (isNaN(d.getTime())) return s;
    try { return d.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' }); } catch (_) { return s; }
  }
  /* Eyebrow + headline. The picture is the media panel (desktop) or the band across the
     top (phones, 2026-10-01), so each layout has exactly one picture and no thumbnail. */
  function viewHead(eyebrow, h) {
    return '<div class="vqp__head">' +
      '<div class="vqp__head-text"><p class="vqp__brand">' + eyebrow + '</p>' +
      '<h2 class="vqp__h" id="vqp-title">' + h + '</h2></div></div>';
  }

  /* Step 1 (2026-10-01, owner): flip a card. HONESTY RULE, non-negotiable: every card
     holds the SAME real offer and no copy here may claim chance, luck, winning or a
     prize. The headline is the article's topic line when there is one. */
  var CARD = { offer: '10% off', line1: 'your first set', line2: 'and the sleep guide' };
  var STEP_ADVANCE_MS = 700;
  function viewFlip() {
    var t = topic();
    var h = t ? t.h : 'Flip a card to reveal your reader offer.';
    var sub = t ? 'Flip a card to reveal your reader offer.' : 'Pick one.';
    var cards = '';
    for (var i = 1; i <= 3; i++) {
      cards += '<button class="vqp__cardbtn" type="button" data-flip="' + i + '" aria-label="Card ' + i + ': flip to reveal your reader offer">' +
        '<span class="vqp__cardin">' +
        '<span class="vqp__cardface vqp__cardface--back"><span class="vqp__moon" aria-hidden="true"></span><span class="vqp__cardnum">' + i + '</span></span>' +
        '<span class="vqp__cardface vqp__cardface--front" aria-hidden="true"><span class="vqp__cardoffer">' + CARD.offer + '</span>' +
        '<span class="vqp__cardline">' + CARD.line1 + '</span><span class="vqp__cardline">' + CARD.line2 + '</span></span>' +
        '</span></button>';
    }
    return '' +
      viewHead('Reader offer', esc(h)) +
      '<p class="vqp__sub">' + esc(sub) + '</p>' +
      '<div class="vqp__cards" data-cards role="group" aria-label="Three cards, pick one">' + cards + '</div>' +
      '<button class="vqp__skip" data-skip type="button">No thanks</button>';
  }
  function stepEvent(step) { gaPopup('veluna_popup_step', { engine: 'guide_popup', surface: surface(), step: step }); }
  function onFlip(btn) {
    var wrap = popupEl && popupEl.querySelector('[data-cards]');
    if (!wrap || wrap.classList.contains('is-picked') || btn.disabled) return;
    wrap.classList.add('is-picked');
    btn.classList.add('is-flipped');
    btn.setAttribute('aria-label', CARD.offer + ' ' + CARD.line1 + ' ' + CARD.line2);
    [].slice.call(wrap.querySelectorAll('[data-flip]')).forEach(function (b) { if (b !== btn) b.disabled = true; });
    stepEvent('flip');
    setTimeout(function () { if (isOpen && popupEl && popupEl.querySelector('[data-cards]')) showEmailStep(); }, STEP_ADVANCE_MS);
  }
  function showEmailStep() {
    render(viewEmail());
    stepEvent('email');
    setTimeout(function () { var f = popupEl && popupEl.querySelector('input[type="email"]'); if (f) { try { f.focus({ preventScroll: true }); } catch (_) {} } }, 40);
  }

  /* Step 2: the email. Articles with a topic keep their topic sub line. */
  function viewEmail() {
    var t = topic();
    return '' +
      viewHead('Reader offer', 'Claim your 10% off') +
      '<p class="vqp__sub">' + esc(t ? t.sub : 'Enter your email and your code appears right here.') + '</p>' +
      '<form class="vqp__form" data-form novalidate>' +
        '<div class="vqp__row">' +
        '<input class="vqp__input" type="email" name="email" placeholder="you@example.com" required autocomplete="email" aria-label="Email address" />' +
        '<button class="vqp__btn" type="submit" data-submit>Claim my offer</button>' +
        '</div>' +
        '<p class="vqp__error" data-error role="status" aria-live="polite"></p>' +
      '</form>' +
      '<p class="vqp__legal">One email a week at most. Unsubscribe any time.</p>' +
      '<p class="vqp__trust"><span>Third-party tested</span><span>30-night guarantee</span></p>' +
      '<button class="vqp__skip" data-skip type="button">No thanks</button>';
  }

  function viewSuccess(j, email) {
    var t = topic();
    var mine = j && j.signup_code;
    return '' +
      viewHead('Your code, ready now', 'Here is your 10% off') +
      '<div class="vqp__code"><span class="vqp__code-value" data-code>' + esc(mine || 'SLEEP10') + '</span>' +
      '<button class="vqp__copy" type="button" data-copy>Copy</button></div>' +
      '<p class="vqp__copied" data-copied role="status" aria-live="polite"></p>' +
      '<p class="vqp__sub vqp__code-note">' + (mine
        ? 'Your own code, works until ' + esc(endsLabel(j.signup_ends || '')) + '. Use it at checkout on your first set or the first delivery of a plan.'
        : 'Use it at checkout on your first set or the first delivery of a plan. Once per customer.') + '</p>' +
      '<div class="vqp__links">' +
      (t ? '<a class="vqp__link vqp__link--topic" href="' + esc(t.link) + '" data-topic-link>' + esc(t.label) + '</a>' : '') +
      '<a class="vqp__link" href="/pages/ritual-essentials" data-sets-link>See the sets</a></div>' +
      '<p class="vqp__legal">The sleep guide is on its way to ' + esc(email || '') + '.</p>' +
      '<p class="vqp__pick" data-pick><span>Pick your evening</span>' +
      '<a href="/pages/ritual-quiz">Mind</a><a href="/pages/ritual-quiz">Body</a><a href="/pages/ritual-quiz">Skin</a></p>';
  }

  function copyCode() {
    var code = popupEl && popupEl.querySelector('[data-code]');
    var note = popupEl && popupEl.querySelector('[data-copied]');
    var value = code ? (code.textContent || '').trim() : '';
    function ok() { if (note) note.textContent = 'Copied. Paste it into the discount box at checkout.'; }
    function fail() { if (note) note.textContent = 'Select the code to copy it.'; }
    try {
      if (value && navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(value).then(ok, fail); return; }
    } catch (_) {}
    fail();
  }

  function buildPopup() {
    if (popupEl) return popupEl;
    injectStyles();
    var overlay = document.createElement('div');
    overlay.className = 'vqp__overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'vqp-title');
    overlay.setAttribute('data-capture-id', 'pdf-capture');
    /* The close X sits last in the DOM (it is positioned top-right anyway) so the first Tab
       from the dialog lands on card 1, not on the X. The card container takes the initial
       focus (tabindex -1, no ring) so no card looks pre-selected on open. */
    overlay.innerHTML = '<div class="vqp__card" tabindex="-1">' +
      '<div class="vqp__media"><img src="' + GUIDE_COVER + '" alt="The Veluna sleep guide" width="300" height="389" decoding="async" /></div>' +
      '<div class="vqp__frame" data-body></div>' +
      '<button class="vqp__close" data-close aria-label="Close">' +
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
      '</button></div>';
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closePopup('backdrop'); });
    overlay.querySelector('[data-close]').addEventListener('click', function () { closePopup('close-btn'); });
    overlay.querySelector('[data-body]').addEventListener('click', function (e) {
      if (e.target.closest('[data-skip]')) { closePopup('skip'); return; }
      var flip = e.target.closest('[data-flip]');
      if (flip) { onFlip(flip); return; }
      if (e.target.closest('[data-copy]')) { copyCode(); }
    });
    overlay.querySelector('[data-body]').addEventListener('submit', function (e) {
      if (e.target.matches('[data-form]')) { e.preventDefault(); onEmailSubmit(e.target); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) closePopup('esc'); });
    document.body.appendChild(overlay);
    popupEl = overlay;
    return popupEl;
  }

  function render(html) { popupEl.querySelector('[data-body]').innerHTML = html; }

  function familyFromCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) return null;
        for (var i = 0; i < cart.items.length; i++) {
          var h = String(cart.items[i].handle || '').toLowerCase();
          for (var j = 0; j < CONFIG.concerns.length; j++) {
            if (h.indexOf(CONFIG.concerns[j].match) !== -1) return CONFIG.concerns[j];
          }
        }
        return null;
      }).catch(function () { return null; });
  }

  function open(reason, preset, kind) {
    buildPopup();
    /* 2026-10-01: step 1 is the flip (viewFlip), the email follows. The concern behind
       the POST is the article's mapped one when there is one, else Mind Calm. */
    selected = preset || defaultConcern();
    render(viewFlip());
    try { window.VelunaCaptureGuard && window.VelunaCaptureGuard.notifyOpen('pdf-capture'); } catch (_) {}
    requestAnimationFrame(function () { popupEl.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
    isOpen = true;
    recordShown();
    popCount('guide');
    try {
      var G = window.VelunaCaptureGuard;
      releaseFocus = G && G.holdFocus ? G.holdFocus(popupEl, { focus: false }) : null;
    } catch (_) { releaseFocus = null; }
    if (surface() === 'cart') ssSet(CONFIG.storage.cartShown, '1');
    setTimeout(function () {
      var f = popupEl && popupEl.querySelector('.vqp__card');
      if (f) { try { f.focus({ preventScroll: true }); } catch (_) {} }
    }, 60);
    /* 2026-10-01: exit_kind names the exit signal (top, predict, side, keyboard, tab-return,
       scroll-up, idle); trigger stays 'exit-intent' for the pointer and keyboard kinds. */
    var shown = { event: 'veluna_popup_shown', trigger: reason, surface: surface() };
    var ga = { engine: 'guide_popup', surface: surface(), trigger: triggerName(reason) };
    if (kind) { shown.exit_kind = kind; ga.exit_kind = kind; }
    try { if (window.dataLayer) window.dataLayer.push(shown); } catch (_) {}
    gaPopup('veluna_popup_shown', ga);
  }

  function showPopup(reason, kind) {
    if (!shouldShow()) return;
    open(reason, surface() === 'article' ? articleConcern() : null, kind);
  }

  function closePopup(reason) {
    if (!popupEl) return;
    popupEl.classList.remove('is-open');
    document.body.style.overflow = '';
    isOpen = false;
    try { window.VelunaCaptureGuard && window.VelunaCaptureGuard.notifyClosed('pdf-capture'); } catch (_) {}
    /* 2026-10-01 (owner): the close counts for this page load only. No dismissal key, no
       guard dismissal (notifyDismissed); the next page asks again unless captured. The
       dismissed event still fires. */
    closedThisPage = true;
    lsSet(CONFIG.storage.lastShown, String(Date.now()));
    if (!isCaptured()) gaPopup('veluna_popup_dismissed', { engine: 'guide_popup', surface: surface() });
    if (dwellTimer) { clearTimeout(dwellTimer); dwellTimer = null; }
    if (releaseFocus) { try { releaseFocus(); } catch (_) {} releaseFocus = null; }
    var el = popupEl;
    setTimeout(function () { if (el) el.remove(); if (popupEl === el) popupEl = null; }, 250);
  }

  function markCaptured(email) {
    lsSet(CONFIG.storage.captured, 'true');
    lsSet('veluna_pdf_captured', email + '|' + Date.now());
    lsSet('veluna_quiz_email', email);
    lsSet('veluna_quiz_email_captured', 'true');
  }

  function onEmailSubmit(form) {
    var input = form.querySelector('input[type="email"]');
    var errEl = form.querySelector('[data-error]');
    var btn = form.querySelector('[data-submit]');
    var email = (input.value || '').trim();
    errEl.textContent = '';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { errEl.textContent = 'Please enter a full email address.'; return; }
    btn.disabled = true; btn.textContent = 'Sending…';
    submitToBackend(email).then(function (res) {
      if (!res || !res.ok) throw new Error('network');
      return res.json().catch(function () { return {}; });
    }).then(function (j) {
      markCaptured(email);
      fireLead({ source: sourceName(), concern: selected.id, surface: surface() });
      render(viewSuccess(j, email));
      setTimeout(function () { var b = popupEl && popupEl.querySelector('[data-copy]'); if (b) { try { b.focus({ preventScroll: true }); } catch (_) {} } }, 40);
      try { if (window.dataLayer) window.dataLayer.push({ event: 'veluna_lead_captured', sleep_concern: selected.id, ritual_type: selected.ritual, surface: surface() }); } catch (_) {}
    }).catch(function () {
      errEl.textContent = 'That did not go through. Please try again.';
      btn.disabled = false; btn.textContent = 'Claim my offer';
    });
  }

  function submitToBackend(email) {
    var c = selected;
    return fetch(CONFIG.backend.url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: email,
        topic: 'popup_subscribe',
        want_code: true,
        /* Top-level concern: this is what routes the welcome email to the
           right guide. Without it the engine falls back to Mind Calm. */
        concern: c.id,
        first_name: '',
        source: sourceName(),
        email_sequence: CONFIG.backend.sequence,
        popup_variant: CONFIG.backend.popupVariant,
        tags: ['veluna_quiz_popup', 'concern_' + c.id, CONFIG.backend.sequence, 'surface_' + surface()],
        fields: { sleep_concern: c.id, ritual_type: c.ritual, email_sequence: CONFIG.backend.sequence,
                  ritual_guide_url: c.guide, popup_variant: CONFIG.backend.popupVariant },
        metadata: { page: window.location.pathname, referrer: document.referrer || '',
                    user_agent: (navigator && navigator.userAgent) || '' }
      })
    }).catch(function () { return null; });
  }

  var FINE_POINTER = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
  function scrolledPast(fraction) {
    var h = document.documentElement;
    return (h.scrollTop + window.innerHeight) / (h.scrollHeight || 1) >= fraction;
  }
  /* 2026-10-01: exit intent comes from the shared detector in veluna-capture-guard.js
     (window.VelunaExitIntent). If that file has not run yet the subscription waits in
     window.__vlnExitQueue and the helper picks it up. */
  function onExitIntent(fn, opts) {
    if (window.VelunaExitIntent && window.VelunaExitIntent.listen) { window.VelunaExitIntent.listen(fn, opts); return; }
    (window.__vlnExitQueue = window.__vlnExitQueue || []).push([fn, opts]);
  }
  function installTriggers() {
    if (triggersInstalled) return;
    triggersInstalled = true;
    var s = surface();
    var loadedAt = Date.now();
    if (s === 'browse') {
      /* Browse pages: exit intent on desktop (below). Touch devices (2026-09-30, retuned
         2026-10-01): 30% scrolled after at least 10 s on the page, the article numbers. */
      {   /* owner 2026-10-01: desktop too (was touch only) */
        var tryBrowse = function (reason) {
          if (Date.now() - loadedAt < CONFIG.timing.articleMobileMinMs || !scrolledPast(CONFIG.timing.articleScroll)) return;
          if (shouldShow()) showPopup(reason);
        };
        window.addEventListener('scroll', function () { tryBrowse('scroll'); }, { passive: true });
        setTimeout(function () { tryBrowse('scroll-dwell'); }, CONFIG.timing.articleMobileMinMs + 50);
      }
      /* owner 2026-10-01 (max leads): 20 s on the page opens it even without scrolling;
         re-checked every 3 s while the guard refuses (buy box on screen etc.). */
      (function () { var n = 0; var t = function () { if (shouldShow()) { showPopup('dwell'); return; } if (++n < 20) setTimeout(t, 3000); }; setTimeout(t, 20000); })();
    } else if (s === 'article') {
      /* Articles: gentle only. Desktop: 30% read (articleScroll), or exit intent below.
         Touch: 30% read AND at least 10 s on the page (articleMobileMinMs, 2026-10-01). */
      var tryArticle = function (reason) {
        if (!scrolledPast(CONFIG.timing.articleScroll)) return;
        if (!FINE_POINTER && Date.now() - loadedAt < CONFIG.timing.articleMobileMinMs) return;
        if (shouldShow()) showPopup(reason);
      };
      window.addEventListener('scroll', function () { tryArticle('scroll'); }, { passive: true });
      if (!FINE_POINTER) setTimeout(function () { tryArticle('scroll-dwell'); }, CONFIG.timing.articleMobileMinMs + 50);
      /* owner 2026-10-01 (max leads): 20 s on the page opens it even without scrolling;
         re-checked every 3 s while the guard refuses (buy box on screen etc.). */
      (function () { var n = 0; var t = function () { if (shouldShow()) { showPopup('dwell'); return; } if (++n < 20) setTimeout(t, 3000); }; setTimeout(t, 20000); })();
    } else {
      window.addEventListener('scroll', function () {
        if (!shouldShow()) return;
        if (scrolledPast(CONFIG.timing.scrollThreshold)) showPopup('scroll');
      }, { passive: true });
      if (dwellTimer) clearTimeout(dwellTimer);
      /* 2026-09-30: re-check every 5 s (up to 12 times) so a guard block at the 20 s mark is not final. */
      var dwellTries = 0;
      var dwellCheck = function () {
        if (shouldShow()) { showPopup('dwell'); return; }
        if (++dwellTries < 12) dwellTimer = setTimeout(dwellCheck, 5000);
      };
      dwellTimer = setTimeout(dwellCheck, CONFIG.timing.dwellMs);
    }
    /* Exit intent (2026-10-01), every surface, no minimum time on the page. Desktop:
       top, predict, side (after 6 s), keyboard, tab-return. Phones: scroll-up (120 px
       back up after 30% depth), idle (8 s still after 30% depth), tab-return. The
       helper never fires while a capture overlay is open. Every kind goes through
       shouldShow(): guard, a close on this page load and "already captured" still
       apply. Only the exit kinds may open while a set card or buy box is on screen
       (EXITING); scroll-up and idle wait like dwell and scroll do. */
    /* back: true (2026-10-01, owner): the helper pushes one history entry; the first Back
       press arrives here as kind 'back' (trigger exit-intent, exit_kind back) and the next
       Back leaves. Returning true tells the helper the popup opened; on false (shouldShow
       refused) the helper leaves the page itself so the press is never swallowed. */
    onExitIntent(function (kind) {
      var exit = kind !== 'scroll-up' && kind !== 'idle';
      EXITING = exit;
      try { if (shouldShow()) { showPopup(exit ? 'exit-intent' : kind, kind); return isOpen; } } finally { EXITING = false; }
      return false;
    }, { minMs: 0, minSideMs: 6000, back: false });   /* back trap OFF (owner 2026-10-01 ~6:30 PM ET) */
  }

  function init() {
    if (!surface()) return;
    /* 2026-10-01: this engine no longer asks the guard to remember a dismissal, so a key an
       earlier version left in this tab (veluna_capture_dismissed_session:pdf-capture[:surface])
       must not keep blocking it through VelunaCaptureGuard.reason(). */
    try { sessionStorage.removeItem('veluna_capture_dismissed_session:pdf-capture:' + surface()); sessionStorage.removeItem('veluna_capture_dismissed_session:pdf-capture'); } catch (_) {}
    if (!PREVIEW && isCaptured()) return;
    installTriggers();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.__velunaPopupTest = function () {
    try { localStorage.removeItem(CONFIG.storage.captured); localStorage.removeItem(CONFIG.storage.dismissed);
          localStorage.removeItem(CONFIG.storage.lastShown); ['home', 'article', 'browse'].forEach(function (sf) { localStorage.removeItem(CONFIG.storage.lastShown + ':' + sf); }); sessionStorage.removeItem(CONFIG.storage.cartShown);
          localStorage.removeItem(CONFIG.storage.dismissedUntil); sessionStorage.removeItem(CONFIG.storage.sessionDismissed); sessionStorage.removeItem('veluna_popup_shows');
          ['home', 'article', 'browse'].forEach(function (sf) { localStorage.removeItem(CONFIG.storage.dismissedUntil + ':' + sf); sessionStorage.removeItem(CONFIG.storage.sessionDismissed + ':' + sf); sessionStorage.removeItem('veluna_capture_dismissed_session:pdf-capture:' + sf); }); } catch (_) {}
    showPopup('manual-test');
  };
})();
